import { site } from "@/data/site";

/** Mensagem única de abertura — a triagem do time de suporte identifica o assunto a partir daí. */
export const DEFAULT_WHATSAPP_MESSAGE = "Olá! Vim pelo site da Alert AI.";

export function whatsappUrl(message: string = DEFAULT_WHATSAPP_MESSAGE) {
  return `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(message)}`;
}
